import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export function AccountPage({ user, isPremium }: { user: any, isPremium: boolean }) {
  const navigate = useNavigate()
  const [profile, setProfile] = useState<any>(null)
  const [cancelling, setCancelling] = useState(false)
  const [cancelled, setCancelled] = useState(false)
  const [cancelAtPeriodEnd, setCancelAtPeriodEnd] = useState(false)

  useEffect(() => {
    if (!user) { navigate('/auth'); return }
    supabase.from('users').select('*').eq('id', user.id).single()
      .then(({ data }) => {
        setProfile(data)
        // Controlla se l'abbonamento è impostato per cancellarsi
        if (data?.stripe_customer_id) {
          // Usiamo premium_expires_at per capire se è attivo
          setCancelAtPeriodEnd(data?.subscription_cancel_at_period_end || false)
        }
      })
  }, [user?.id])

  const handleCancelSubscription = async () => {
    if (!window.confirm('Sei sicuro di voler cancellare il tuo abbonamento Premium?')) return
    setCancelling(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const { error } = await supabase.functions.invoke('cancel-subscription', {
        headers: { Authorization: 'Bearer ' + session?.access_token }
      })
      if (error) throw error
      setCancelAtPeriodEnd(true)
      setCancelled(true)
    } catch (err: any) {
      alert('Errore: ' + err.message)
    }
    setCancelling(false)
  }

  const handleExportData = async () => {
    try {
      const { data: profileData } = await supabase.from('users').select('*').eq('id', user.id).single()
      const { data: plansData } = await supabase.from('plans').select('*').eq('user_id', user.id)
      const exportData = {
        account: {
          email: user.email,
          created_at: user.created_at,
          is_premium: profileData?.is_premium || false,
          premium_expires_at: profileData?.premium_expires_at || null,
        },
        plans: plansData || [],
        exported_at: new Date().toISOString()
      }
      const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: "application/json" })
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = "my-data-studyplanner.json"
      a.click()
      URL.revokeObjectURL(url)
    } catch (err: any) {
      alert("Errore: " + err.message)
    }
  }

  const handleDeleteAccount = async () => {
    if (!window.confirm("Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile e cancellerà tutti i tuoi dati.")) return
    try {
      await supabase.functions.invoke("delete-account", {
        body: { user_id: user?.id }
      })
      await supabase.auth.signOut()
      navigate("/")
    } catch (err: any) {
      alert("Errore: " + err.message)
    }
  }

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/')
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8F9FA' }}>
      <header style={{ backgroundColor: 'white', borderBottom: '1px solid #E5E7EB', padding: '12px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 20, fontWeight: 'bold', color: '#111827', margin: 0 }}>👤 Il mio account</h1>
        <button onClick={() => navigate('/')} style={{ fontSize: 13, color: '#6B7280', backgroundColor: 'white', border: '1px solid #E5E7EB', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' }}>
          ← Torna all'app
        </button>
      </header>

      <div style={{ maxWidth: 560, margin: '0 auto', padding: '32px 16px', display: 'flex', flexDirection: 'column', gap: 16 }}>

        {/* Info utente */}
        <div style={{ backgroundColor: 'white', borderRadius: 16, padding: 24, border: '1px solid #E5E7EB' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 16 }}>
            <div style={{ width: 52, height: 52, borderRadius: '50%', backgroundColor: '#1c3fff', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 20, fontWeight: 700 }}>
              {(user?.user_metadata?.name || user?.email || 'U').charAt(0).toUpperCase()}
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>{user?.user_metadata?.name || 'Utente'}</div>
              <div style={{ fontSize: 13, color: '#6B7280' }}>{user?.email}</div>
            </div>
          </div>
        </div>

        {/* Stato abbonamento */}
        <div style={{ backgroundColor: 'white', borderRadius: 16, padding: 24, border: '1px solid #E5E7EB' }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: '0 0 16px' }}>📋 Abbonamento</h2>
          {isPremium ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <span style={{ backgroundColor: cancelAtPeriodEnd || cancelled ? '#FEF3C7' : '#DCFCE7', color: cancelAtPeriodEnd || cancelled ? '#D97706' : '#16A34A', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>
                  {cancelAtPeriodEnd || cancelled ? '⚠️ CANCELLAZIONE IN CORSO' : '✦ PREMIUM ATTIVO'}
                </span>
              </div>
              {profile?.premium_expires_at && (
                <div style={{ backgroundColor: cancelAtPeriodEnd || cancelled ? '#FEF3C7' : '#F0FDF4', borderRadius: 10, padding: '12px 16px', marginBottom: 16 }}>
                  {cancelAtPeriodEnd || cancelled ? (
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#D97706', marginBottom: 4 }}>
                        Il Premium rimarrà attivo fino al:
                      </div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#111827' }}>
                        {new Date(profile.premium_expires_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
                      </div>
                      <div style={{ fontSize: 13, color: '#6B7280', marginTop: 4 }}>
                        Dopo questa data l'abbonamento verrà interrotto e non verrà addebitato nulla.
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#16A34A', marginBottom: 4 }}>
                        Prossimo rinnovo:
                      </div>
                      <div style={{ fontSize: 18, fontWeight: 800, color: '#111827' }}>
                        {new Date(profile.premium_expires_at).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {!cancelled && !cancelAtPeriodEnd ? (
                <button onClick={handleCancelSubscription} disabled={cancelling} style={{ backgroundColor: '#FEF2F2', color: '#EF4444', border: '1px solid #FECACA', borderRadius: 10, padding: '10px 20px', cursor: 'pointer', fontSize: 14, fontWeight: 600, opacity: cancelling ? 0.6 : 1 }}>
                  {cancelling ? 'Cancellazione...' : 'Cancella rinnovo automatico'}
                </button>
              ) : (
                <div style={{ fontSize: 13, color: '#6B7280' }}>
                  Il rinnovo automatico è stato disattivato.
                </div>
              )}
            </div>
          ) : (
            <div>
              <div style={{ fontSize: 14, color: '#6B7280', marginBottom: 16 }}>Nessun abbonamento attivo</div>
              <button onClick={() => navigate('/')} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 10, padding: '10px 20px', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                ✦ Passa a Premium
              </button>
            </div>
          )}
        </div>

        {/* Azioni */}
        <div style={{ backgroundColor: 'white', borderRadius: 16, padding: 24, border: '1px solid #E5E7EB' }}>
          <h2 style={{ fontSize: 15, fontWeight: 700, color: '#111827', margin: '0 0 16px' }}>⚙️ Azioni</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <button onClick={() => navigate('/plans')} style={{ backgroundColor: '#F9FAFB', color: '#111827', border: '1px solid #E5E7EB', borderRadius: 10, padding: '12px 16px', cursor: 'pointer', fontSize: 14, textAlign: 'left' }}>
              📚 I miei piani salvati
            </button>
            <button onClick={handleExportData} style={{ backgroundColor: '#F9FAFB', color: '#111827', border: '1px solid #E5E7EB', borderRadius: 10, padding: '12px 16px', cursor: 'pointer', fontSize: 14, textAlign: 'left' }}>
              📥 Scarica i miei dati
            </button>
            <button onClick={handleLogout} style={{ backgroundColor: '#F9FAFB', color: '#EF4444', border: '1px solid #E5E7EB', borderRadius: 10, padding: '12px 16px', cursor: 'pointer', fontSize: 14, textAlign: 'left' }}>
              🚪 Esci dall'account
            </button>
            <button onClick={handleDeleteAccount} style={{ backgroundColor: '#FEF2F2', color: '#EF4444', border: '1px solid #FECACA', borderRadius: 10, padding: '12px 16px', cursor: 'pointer', fontSize: 14, textAlign: 'left' }}>
              🗑️ Elimina account
            </button>
          </div>
        </div>

      </div>
    </div>
  )
}
